import Reveal from "@/components/Reveal";
import { Eye, Heart, MessageCircle, Sparkles, Compass, Layers, Shuffle } from "lucide-react";

const RESULTS = [
  { icon: Eye, t: "Más visibilidad", d: "Apareces donde se toman las decisiones de compra." },
  { icon: Heart, t: "Más confianza", d: "Los clientes llegan convencidos, no solo comparando precio." },
  { icon: MessageCircle, t: "Mejores conversaciones", d: "Gente con intención real, no formularios fríos." },
  { icon: Sparkles, t: "Mejor percepción", d: "Te ven profesional, moderno y distinto." },
  { icon: Shuffle, t: "Menos dependencia del azar", d: "Crecimiento ordenado, no a base de suerte y boca a boca." },
  { icon: Layers, t: "Más control", d: "Captación y seguimiento ordenados; nada se pierde." },
];

export default function Benefits() {
  return (
    <section id="resultados" data-testid="benefits-section" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal>
          <div className="font-stencil text-xs text-[#00A0A0] tracking-widest mb-4">05 / RESULTADOS</div>
          <h2 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl uppercase tracking-tight leading-[0.95] max-w-4xl">
            LO QUE CAMBIA CUANDO
            <br />
            <span className="font-stencil text-[#FFD700]">ENTRAS AL SISTEMA.</span>
          </h2>
        </Reveal>

        <Reveal delay={150}>
          <p className="mt-8 text-base lg:text-lg text-white/60 max-w-2xl leading-relaxed font-body">
            Sin promesas mágicas. Esto es lo que empieza a pasar cuando contenido, marca y captación trabajan juntos:
          </p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {RESULTS.map((r, i) => (
            <Reveal key={r.t} delay={i * 60}>
              <div data-testid={`benefit-${i}`} className="group h-full bg-[#0a0a0a] p-8 lg:p-10 hover:bg-[#0f0f0f] transition-colors duration-500 relative overflow-hidden">
                <div className="absolute -top-6 -right-6 font-stencil text-7xl text-white/[0.04] select-none">0{i + 1}</div>
                <div className="relative">
                  <div className="w-12 h-12 border border-[#00A0A0]/40 bg-[#00A0A0]/5 flex items-center justify-center mb-6 group-hover:border-[#FFD700]/60 transition-colors">
                    <r.icon className="w-5 h-5 text-[#00A0A0] group-hover:text-[#FFD700] transition-colors" strokeWidth={1.75} />
                  </div>
                  <h3 className="font-stencil text-xl text-white uppercase tracking-wide mb-3">{r.t}</h3>
                  <p className="text-sm text-white/55 leading-relaxed font-body">{r.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
